import { AbstractControl, ValidatorFn } from '@angular/forms';

// Cannot contain only letters
export function mixedCharactersValidator(): ValidatorFn {
	return (control: AbstractControl) => {
		const hasLetters = /([a-z]+)/i;
		const nonLetters = /([^a-z]+)/i;

		return (hasLetters.test(control.value) && nonLetters.test(control.value)) || control.value === ''
			? null
			: { mixedCharacters: true };
	};
}
